/* Listing with licensed brand filters: loads every product of a collection or brand, then filters, searches, sorts and pages them. State stays in the address. */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const PER = 24;
  const SHOW = 10;
  const NO_LICENSE = 'No license on record';
  const NO_TYPE = 'Not yet classified';
  const BRANDS = { SOTT: 'Sign of the Times' };
  const LABELS = { license: 'Licensed brand', type: 'Product type', stock: 'Availability', theme: 'Theme' };

  /* Reads every page of the feed. The feed states its own total, so a short read is reported, not hidden. */
  async function loadFeed(feed) {
    const out = [], seen = new Set();
    let total = null;
    for (let page = 1; page <= 40; page++) {
      const r = await fetch(`${feed}&page=${page}`, { credentials: 'same-origin' });
      if (!r.ok) throw new Error('feed ' + r.status);
      const j = JSON.parse(await r.text());
      total = j.total;
      j.p.forEach(p => { if (!seen.has(p.id)) { seen.add(p.id); out.push(p); } });
      if (!j.next) break;
    }
    return { products: out, total };
  }

  function init(root) {
    const mode = root.dataset.mode || 'brand';
    const native = root.dataset.nativeTarget ? $(root.dataset.nativeTarget) : null;
    const groups = (root.dataset.groups || 'license,type,price,stock').split(',');
    const checks = groups.filter(k => k !== 'price');
    const brandCode = root.dataset.brandCode || '';
    const q = new URLSearchParams(location.search);
    const S = { q: q.get('q') || '', sort: q.get('sort') || 'featured', page: parseInt(q.get('page'), 10) || 1, min: q.get('min') || '', max: q.get('max') || '', f: {} };
    checks.forEach(k => { S.f[k] = q.getAll(k); });
    const hadFilter = S.q || S.min || S.max || checks.some(k => S.f[k].length) || q.get('page');
    const more = {};
    const status = $('[data-aad-listing-count]', root);
    const grid = $('[data-aad-listing-grid]', root);
    let items = [], ranks = {}, expected = 0;

    /* A failed or partial load must not leave a partial list on screen. A collection falls back to Shopify's own page. */
    function fail(message) {
      root.dataset.state = 'failed';
      root.dataset.message = message;
      if (native) {
        root.hidden = true;
        native.hidden = false;
        const note = $('[data-aad-native-note]', native);
        if (note) { note.hidden = false; note.textContent = message + ' Showing the standard filters, which do not include licensed brands.'; }
        return;
      }
      grid.innerHTML = '';
      status.textContent = message + ' Please reload the page.';
      $('[data-aad-listing-skeleton]', root).hidden = true;
    }

    /* Native filter links keep working: a page opened with them stays on Shopify's own grid, so two grids never disagree. */
    if (native && Array.from(q.keys()).some(k => k.startsWith('filter.') || k === 'sort_by')) {
      root.hidden = true;
      native.hidden = false;
      root.dataset.state = 'native';
      return;
    }

    const inPrice = p => {
      const d = p.n / 100;
      return (S.min === '' || d >= parseFloat(S.min)) && (S.max === '' || d <= parseFloat(S.max));
    };
    const passes = (p, skip) => {
      if (S.q) {
        const hay = (p.t + ' ' + p.license + ' ' + p.type + ' ' + p.theme + ' ' + p.artist).toLowerCase();
        if (!S.q.toLowerCase().split(/\s+/).every(w => hay.includes(w))) return false;
      }
      if (skip !== 'price' && !inPrice(p)) return false;
      return checks.every(k => k === skip || !S.f[k].length || S.f[k].includes(p[k]));
    };
    const sync = () => {
      const was = new URLSearchParams(location.search), u = new URLSearchParams();
      ['view', 'preview_theme_id'].forEach(k => { if (was.get(k)) u.set(k, was.get(k)); });
      if (S.q) u.set('q', S.q);
      checks.forEach(k => S.f[k].forEach(v => u.append(k, v)));
      if (S.min !== '') u.set('min', S.min);
      if (S.max !== '') u.set('max', S.max);
      if (S.sort !== 'featured') u.set('sort', S.sort);
      if (S.page > 1) u.set('page', S.page);
      const s = u.toString();
      history.replaceState({}, '', location.pathname + (s ? '?' + s : '') + location.hash);
    };
    const card = p => {
      const on = !!p.c;
      const badge = !p.a ? '<span class="aad-badge">Sold out</span>' : on ? '<span class="aad-badge aad-badge--sale">Sale</span>' : '';
      return `<li><article class="aad-card">
        <a class="aad-card__tile" href="/products/${esc(p.h)}" aria-label="${esc(p.t)}" tabindex="-1">${badge}
          ${p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy">` : ''}${p.j ? `<img class="aad-card__alt" src="${esc(p.j)}" alt="" loading="lazy">` : ''}
        </a>
        <div class="aad-card__meta">${p.label ? `<span class="aad-card__br">${esc(p.label)}</span>` : ''}
          <a class="aad-card__ttl" href="/products/${esc(p.h)}" title="${esc(p.t)}">${esc(p.t)}</a>
          ${p.f ? `<span class="aad-card__fact">${esc(p.f)}</span>` : ''}
          <span class="aad-price${on ? ' aad-price--on' : ''}">${p.v ? 'From ' : ''}${esc(p.m)}${on && !p.v ? `<s>${esc(p.c)}</s>` : ''}</span>
        </div></article></li>`;
    };
    const order = (k, counts) => (a, b) => {
      const last = v => v === NO_LICENSE || v === NO_TYPE;
      if (last(a) !== last(b)) return last(a) ? 1 : -1;
      if (k === 'theme') return a.localeCompare(b);
      return (counts[b] || 0) - (counts[a] || 0) || a.localeCompare(b);
    };
    function priceGroup(prefix) {
      const top = Math.ceil(Math.max(0, ...items.map(p => p.n)) / 100);
      return `<details class="aad-fgroup" open data-group="price"><summary>Price</summary><div class="aad-fprice">
        <label class="aad-visually-hidden" for="${prefix}Min">Minimum price</label><input id="${prefix}Min" type="number" min="0" inputmode="decimal" data-price="min" placeholder="$0" value="${esc(S.min)}">
        <span aria-hidden="true">to</span>
        <label class="aad-visually-hidden" for="${prefix}Max">Maximum price</label><input id="${prefix}Max" type="number" min="0" inputmode="decimal" data-price="max" placeholder="$${top}" value="${esc(S.max)}">
      </div></details>`;
    }
    function checkGroup(k) {
      const counts = {};
      items.filter(p => passes(p, k)).forEach(p => { if (p[k]) counts[p[k]] = (counts[p[k]] || 0) + 1; });
      const vals = Array.from(new Set(Object.keys(counts).concat(S.f[k]))).sort(order(k, counts));
      if (!vals.length) return '';
      const cut = !more[k] && k === 'license' && vals.length > SHOW + 2;
      return `<details class="aad-fgroup" open data-group="${k}"><summary>${LABELS[k]}</summary>${vals.map((v, i) => {
        const on = S.f[k].includes(v);
        const hide = cut && i >= SHOW && !on && v !== NO_LICENSE;
        return `<label class="aad-fopt"${hide ? ' hidden' : ''}><input type="checkbox" data-k="${k}" value="${esc(v)}"${on ? ' checked' : ''}><span>${esc(v)}</span><span class="aad-fopt__ct">${counts[v] || 0}</span></label>`;
      }).join('')}${cut ? `<button type="button" class="aad-fmore" data-more="${k}">Show all ${vals.length}</button>` : ''}</details>`;
    }
    function renderFilters() {
      [[$('[data-aad-listing-filters]', root), 'AadLd'], [$('[data-aad-listing-filters-m]', root), 'AadLm']].forEach(([el, prefix]) => {
        const closed = {};
        $$('details', el).forEach(d => { closed[d.dataset.group] = !d.open; });
        el.innerHTML = groups.map(k => k === 'price' ? priceGroup(prefix) : checkGroup(k)).join('');
        $$('details', el).forEach(d => { if (closed[d.dataset.group]) d.open = false; });
      });
    }
    function render() {
      const sorted = items.filter(p => passes(p));
      if (S.sort === 'low') sorted.sort((a, b) => a.n - b.n);
      if (S.sort === 'high') sorted.sort((a, b) => b.n - a.n);
      if (S.sort === 'az') sorted.sort((a, b) => a.t.localeCompare(b.t));
      if (S.sort === 'new') sorted.sort((a, b) => b.d - a.d);
      if (S.sort === 'best') sorted.sort((a, b) => (ranks[a.id] ?? 1e9) - (ranks[b.id] ?? 1e9));
      const pages = Math.max(1, Math.ceil(sorted.length / PER));
      if (S.page > pages) S.page = pages;
      grid.innerHTML = sorted.slice((S.page - 1) * PER, S.page * PER).map(card).join('');
      $('[data-aad-listing-skeleton]', root).hidden = true;
      $('[data-aad-listing-empty]', root).hidden = sorted.length > 0;
      const active = S.q || S.min !== '' || S.max !== '' || checks.some(k => S.f[k].length);
      status.textContent = active ? `${sorted.length} of ${items.length} products` : `${items.length} products`;
      renderFilters();
      const chips = [];
      checks.forEach(k => S.f[k].forEach(v => chips.push(`<button type="button" class="aad-chip" data-chip-k="${k}" data-chip-v="${esc(v)}" aria-label="Remove filter ${esc(v)}">${esc(v)} <span aria-hidden="true">&times;</span></button>`)));
      if (S.min !== '' || S.max !== '') chips.push(`<button type="button" class="aad-chip" data-chip-price aria-label="Remove price filter">${S.min !== '' ? '$' + esc(S.min) : '$0'} to ${S.max !== '' ? '$' + esc(S.max) : 'any'} <span aria-hidden="true">&times;</span></button>`);
      if (S.q) chips.push(`<button type="button" class="aad-chip" data-chip-q aria-label="Clear search">&ldquo;${esc(S.q)}&rdquo; <span aria-hidden="true">&times;</span></button>`);
      const cw = $('[data-aad-listing-chips]', root);
      cw.hidden = !chips.length;
      cw.innerHTML = chips.join('') + (chips.length ? '<button type="button" class="aad-tlink" data-aad-listing-clear style="background:none;border:0;padding:0">Clear all</button>' : '');
      const nFilters = checks.reduce((n, k) => n + S.f[k].length, 0) + (S.min !== '' || S.max !== '' ? 1 : 0);
      const fb = $('[data-aad-listing-fbtn]', root);
      if (fb) fb.textContent = nFilters ? `Filters (${nFilters})` : 'Filters';
      const nums = [];
      for (let i = 1; i <= pages; i++) if (i === 1 || i === pages || Math.abs(i - S.page) <= 1) nums.push(i); else if (nums[nums.length - 1] !== 0) nums.push(0);
      $('[data-aad-listing-pager]', root).innerHTML = pages < 2 ? '' :
        (S.page > 1 ? `<button type="button" data-page="${S.page - 1}" aria-label="Previous page">&lsaquo;</button>` : '') +
        nums.map(n => n === 0 ? '<span class="is-gap">&hellip;</span>' : n === S.page ? `<span class="is-current" aria-current="page">${n}</span>` : `<button type="button" data-page="${n}">${n}</button>`).join('') +
        (S.page < pages ? `<button type="button" data-page="${S.page + 1}" aria-label="Next page">&rsaquo;</button>` : '');
      sync();
    }
    const top = () => { const t = root.getBoundingClientRect().top + scrollY - 130; window.scrollTo({ top: t }); };
    /* Best selling comes from Shopify's own sort of this feed. It is only read when a shopper asks for it. */
    async function sortBest() {
      const sel = $('[data-aad-listing-sort]', root);
      if (Object.keys(ranks).length) return render();
      status.textContent = 'Sorting products';
      try {
        const { products } = await loadFeed(root.dataset.feed + '&sort_by=best-selling');
        products.forEach((p, i) => { ranks[p.id] = i; });
        render();
      } catch (e) {
        S.sort = 'featured'; sel.value = 'featured'; render();
        status.textContent += '. Best selling could not be loaded.';
      }
    }

    root.addEventListener('change', e => {
      const t = e.target;
      if (t.matches('input[type=checkbox][data-k]')) {
        const a = S.f[t.dataset.k];
        if (t.checked) a.push(t.value); else a.splice(a.indexOf(t.value), 1);
        S.page = 1; render();
      }
      if (t.matches('[data-price]')) {
        const v = t.value.trim();
        S[t.dataset.price] = v !== '' && parseFloat(v) >= 0 ? String(parseFloat(v)) : '';
        S.page = 1; render();
      }
      if (t.matches('[data-aad-listing-sort]')) {
        S.sort = t.value; S.page = 1;
        $$('[data-aad-listing-sort]', root).forEach(x => { x.value = S.sort; });
        if (S.sort === 'best') sortBest(); else render();
      }
    });
    let timer;
    const box = $('[data-aad-listing-q]', root);
    box.value = S.q;
    box.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => { S.q = box.value.trim(); S.page = 1; render(); }, 200); });
    const clearAll = () => { checks.forEach(k => { S.f[k] = []; }); S.q = ''; S.min = ''; S.max = ''; box.value = ''; S.page = 1; render(); };
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-page]');
      if (b) { S.page = +b.dataset.page; render(); top(); return; }
      const m = e.target.closest('[data-more]');
      if (m) { more[m.dataset.more] = true; renderFilters(); return; }
      const c = e.target.closest('[data-chip-k]');
      if (c) { const a = S.f[c.dataset.chipK]; a.splice(a.indexOf(c.dataset.chipV), 1); S.page = 1; render(); return; }
      if (e.target.closest('[data-chip-price]')) { S.min = ''; S.max = ''; S.page = 1; render(); return; }
      if (e.target.closest('[data-chip-q]')) { S.q = ''; box.value = ''; S.page = 1; render(); return; }
      if (e.target.closest('[data-aad-listing-clear]')) clearAll();
    });
    $$('[data-aad-listing-sort]', root).forEach(x => { x.value = S.sort; });

    Promise.all([
      loadFeed(root.dataset.feed),
      fetch(root.dataset.facets, { credentials: 'omit' }).then(r => { if (!r.ok) throw new Error('facets ' + r.status); return r.json(); }),
    ]).then(([feed, facets]) => {
      const fmt = (p, m) => ({
        ...p,
        license: (m && m[0]) || NO_LICENSE,
        type: (m && m[1]) || NO_TYPE,
        theme: (m && m[3]) || '',
        artist: (m && m[4]) || '',
        label: BRANDS[m && m[2]] || '',
        stock: p.a ? 'In stock' : 'Out of stock',
      });
      if (mode === 'brand') {
        expected = Object.values(facets).filter(m => m[2] === brandCode).length;
        items = feed.products.filter(p => facets[p.id] && facets[p.id][2] === brandCode).map(p => fmt(p, facets[p.id]));
        if (feed.products.length !== feed.total) return fail(`Only ${feed.products.length} of ${feed.total} products loaded.`);
      } else {
        expected = feed.total;
        items = feed.products.map(p => fmt(p, facets[p.id]));
        if (items.length !== feed.total) return fail(`Only ${items.length} of ${feed.total} products loaded.`);
      }
      root.dataset.loaded = items.length;
      root.dataset.expected = expected;
      root.dataset.state = 'ready';
      render();
      if (S.sort === 'best') sortBest();
      if (hadFilter) top();
    }).catch(() => fail('The full product list could not be loaded.'));
  }
  function boot() { $$('[data-aad-listing]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => { $$('[data-aad-listing]', e.target).forEach(init); });
})();
